<template>
  <section class="container">
    <el-form label-width="100px">
      <el-form-item label="标题">
        <!-- <el-input v-model="editObject.experience_title"/> -->
        <span v-text="editObject.experience_title"/>
      </el-form-item>
      <el-form-item label="副标题">
        <!-- <el-input v-model="editObject.experience_son_title"/> -->
        <span v-text="editObject.experience_son_title"/>
      </el-form-item>
      <el-form-item label="描述">
        <!-- <el-input v-model="editObject.experience_desc"/> -->
        <span v-text="editObject.experience_desc"/>
      </el-form-item>
      <el-form-item label="英文标题">
        <!-- <el-input v-model="editObject.experience_title"/> -->
        <span v-text="editObject.experience_english_title"/>
      </el-form-item>
      <el-form-item label="英文副标题">
        <!-- <el-input v-model="editObject.experience_son_title"/> -->
        <span v-text="editObject.experience_english_son_title"/>
      </el-form-item>
      <el-form-item label="英文描述">
        <!-- <el-input v-model="editObject.experience_desc"/> -->
        <span v-text="editObject.experience_english_desc"/>
      </el-form-item>
      <el-form-item label="图片">
        <!-- <el-upload
          class="avatar-uploader"
          :action="uploadDomain"
          :data="uploadData"
          :on-success="uploadSuccess"
          :show-file-list="false"> -->
        <img
          v-if="editObject.experience_img"
          :src="qiniuDomain + editObject.experience_img"
          class="avatar">
          <!-- <i
            v-else
            class="el-icon-plus avatar-uploader-icon"/>
        </el-upload> -->
      </el-form-item>
      <el-form-item label="banner">
        <div
          v-for="(item, index) in editObject.banner"
          :key="index"
          class="banner-box">
          <img
            :src="qiniuDomain + item.experience_carousel"
            class="banner-img" >
        </div>
      </el-form-item>
    </el-form>

  </section>
</template>

<script>
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  storeDetail,
} from '@/api/store'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      editObject: { //  根据接口来的命名，不是很喜欢---
        experience_title: '',
        experience_desc: '',
        experience_img: '',
        experience_son_title: '',
        experience_english_title: '',
        experience_english_desc: '',
        experience_english_son_title: '',
        banner: [],
      },
    };
  },
  created() {
    this.network().getQiniuInfo()
    this.network().storeDetail()
  },
  methods: {
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        storeDetail: async () => {
          const { status, data } = await storeDetail({
            uuid: this.$route.params.uuid,
          })
          if (status === 200) {
            this.editObject = data
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .banner-box {
    position: relative;
    margin-right: 20px;
    display: inline-block;
    width: 200px;
    height: 100px;
  }
  .banner-box .icon {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    cursor: pointer;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/store/detail.vue